import { Platform, StyleSheet } from 'react-native';

import { WINDOW_WIDTH } from '@gorhom/bottom-sheet';

import { Fonts } from 'assets/fonts';

import { COLOR, blackTransparent } from 'utils/colors';
import {
    heightPercentageToDP,
    isTablet,
    isTabletOrWeb,
    screenWidth,
    widthPercentageToDP,
} from 'utils/responsiveness';

import { TABLET_GALLERY_HEIGHT } from '../../styles';

const styles = StyleSheet.create({
    root: {
        height: TABLET_GALLERY_HEIGHT,
        width: screenWidth,
    },
    container: {
        flex: 1,
        backgroundColor: blackTransparent(1),
    },
    imageContainer: {
        position: 'absolute',
        flexDirection: 'row',
        height: '100%',
        width: '100%',
    },
    coverImage: {
        top: 0,
        right: 0,
        position: 'absolute',
    },
    contentContainer: {
        zIndex: 1,
        paddingLeft: widthPercentageToDP(
            Platform.select({ web: 72, default: 44 }),
        ),
        position: 'absolute',
        bottom: Platform.select({
            web: heightPercentageToDP(180),
            ios: isTablet ? heightPercentageToDP(80) : 80,
            default: 80,
        }),
    },
    accessibilityContainer: {
        width: '100%',
        height: '100%',
        justifyContent: 'flex-end',
    },
    channelLogo: {
        height: heightPercentageToDP(32),
        width: widthPercentageToDP(100),
    },
    title: {
        maxWidth: 500,
        lineHeight: 40,
    },
    metadataContainer: {
        marginTop: heightPercentageToDP(8),
        flexDirection: 'row',
        alignItems: 'center',
    },
    markerContainer: {
        marginTop: 20,
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    marker: {
        height: 20,
        borderRadius: 20,
        alignSelf: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: 0,
        marginRight: isTabletOrWeb ? 12 : 8,
    },
    markerIcons: {
        marginLeft: 0,
        marginRight: 12,
    },
    metadataText: {
        marginTop: 10,
    },
    progressBar: {
        width: widthPercentageToDP(320),
        height: heightPercentageToDP(4),
        marginTop: heightPercentageToDP(11),
    },
    buttonsContainer: {
        flexDirection: 'row',
    },
    button: {
        alignSelf: 'flex-start',
        width: 'auto',
        minWidth: widthPercentageToDP(120),
        maxWidth: WINDOW_WIDTH - widthPercentageToDP(44 * 2),
        paddingLeft: 18,
        paddingRight: 24,
    },
    buttonText: {
        marginLeft: 10,
        color: COLOR.background,
    },
    buttonIcon: {
        width: 'auto',
        paddingHorizontal: widthPercentageToDP(12),
        marginRight: widthPercentageToDP(12),
    },
    descriptionTextStyle: {
        textAlign: 'left',
    },
    seriesMetadata: {
        fontFamily: Fonts.main.regular,
        marginTop: isTablet ? 16 : 8,
    },
    lockIcon: {
        flex: 1,
        marginRight: 110,
        alignItems: 'flex-end',
    },
    lockIconWeb: {
        flex: 1,
        marginTop: 40,
        marginRight: 150,
        alignItems: 'flex-end',
    },
});

export default styles;
